import React, { useEffect, useState } from "react";
import FormatDateTime from "../../../Functions/FormatDate";
import { useLanguage } from "../../../Translations/LenguageContext";
import Spinner from "../../../Components/Spinner";
import MainActionsLoader from "../../../Loaders/MainActionsLoader";
import ActionLoader from "../../../Loaders/ActionLoader";
import { TbReload } from "react-icons/tb";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const GeoActionsMain = ({
    account_id,
    org_id,
    geo_id
}) => {
    const { t } = useLanguage()
    const [openAction, setOpenAction] = useState(null)
    const [monitoring, setMonitoring] = useState([])
    const [actions, setActions] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingAction, setLoadingAction] = useState(false)
    const [startOpenAction, setStartOpenAction] = useState(false)
    const [actionId, setActionId] = useState(null)
    const [sortOrder, setSortOrder] = useState("asc");
    const [searchTerm, setSearchTerm] = useState("");

    const getActions = async () => {
        setLoading(true);

        try {
            const response = await fetch(
                `${GEN_BACKEND_LINK}/get_geo_actions`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        account_id,
                        org_id,
                        geo_id
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            const monitoringActions = (result.monitoring || []).map((created_at, index) => ({
                id: `monitoring-${index}`,
                title: t.geo.monitoring_title,
                summary: t.geo.monitoring_summary,
                created_at,
                type: "MONITORING",
            }));

            const allActions = [
                ...monitoringActions,
                ...(result.strategies || []),
            ].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            setActions(allActions);
            setMonitoring(result.monitoring);

        } catch (err) {
            console.error("Error fetching GEO optimization:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    const getAction = async (action_id) => {
        setLoadingAction(true);

        try {
            const response = await fetch(
                `${GEN_BACKEND_LINK}/get_geo_action`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        account_id,
                        org_id,
                        geo_id,
                        action_id
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setOpenAction(result.action)

        } catch (err) {
            console.error("Error fetching GEO optimization:", err);
        } finally {
            setTimeout(() => {
                setLoadingAction(false);
            }, 500);
        }
    };

    const filteredActions = (actions || [])
        .filter((action) => {
            const term = searchTerm.trim().toLowerCase();

            if (!term) return true;

            const createdAt = action.created_at
                ? FormatDateTime(action.created_at)
                : "";

            return [
                action.title,
                action.summary,
                createdAt,
                action.created_at,
            ].some((value) =>
                String(value ?? "").toLowerCase().includes(term)
            );
        })
        .sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();

            return sortOrder === "asc"
                ? dateA - dateB
                : dateB - dateA;
        });

    const clickAction = (action) => {
        setActionId(action.id)
        setStartOpenAction(true)
        if (action.type == "AGENT_STRATEGY") {
            getAction(action.id)
            setLoadingAction(true)
        } else {
            setLoadingAction(true)
            setOpenAction(action)
            setTimeout(() => {
                setLoadingAction(false)
            }, 500);
        }
    }

    useEffect(() => {
        getActions()
    }, [account_id, org_id, geo_id]);


    return (
        <div className="main_actions_cont">
            {loading ? (
                <MainActionsLoader />
            ) : (
                <>
                    <div className="actions_list_cont">
                            <div className="actions_list_cont_header">
                                <div className="filtering_mainframe_btn_cont fade-in">
                                    {actions?.length > 1 && (
                                        <>
                                            <button
                                                className={`filter_btn filter_btn_actions ${sortOrder === "asc" ? "active" : ""}`}
                                                onClick={() => setSortOrder("asc")}
                                                title="Oldest first"
                                            >
                                                <GrAscend />
                                            </button>

                                            <button
                                                className={`filter_btn filter_btn_actions ${sortOrder === "desc" ? "active" : ""}`}
                                                onClick={() => setSortOrder("desc")}
                                                title="Newest first"
                                            >
                                                <GrDescend />
                                            </button>
                                        </>
                                    )}
                                    <button
                                        className="filter_btn filter_btn_actions"
                                        onClick={() => getActions()}
                                        title={t.reload}
                                    >
                                        <TbReload />
                                    </button>
                                </div>
                                <div className="filter_input_cont fade-in">
                                    <input
                                        className="filter_input"
                                        placeholder={t.search_filter}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                                </div>
                            </div>
                        <div className="actions_list_cont_inner">

                            {filteredActions.map((action) => (
                                <div
                                    className={`actions_item fade-in ${(actionId == action.id) && "actions_item_selected"}`}
                                    key={action.id}
                                    onClick={() => {
                                        clickAction(action);
                                    }}
                                >
                                    <p className="actions_item_title fade-in">
                                        {action.title}
                                        {(loadingAction && actionId == action.id) ? (
                                            <span className="fade-in">
                                                <Spinner loading={loadingAction} />
                                            </span>
                                        ) : (
                                            <span className="fade-in">{FormatDateTime(action.created_at)}</span>
                                        )}
                                    </p>
                                    <p className="actions_item_desc fade-in">{action.summary}</p>
                                </div>
                            ))}
                            {filteredActions.length === 0 && (
                                <div className="organizations_cont_no_items_mex fade-in">
                                    <p>{t.no_data_found_by_search}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="open_action_cont">
                        {startOpenAction ? (
                            loadingAction ? (
                                <ActionLoader />
                            ) : (
                                openAction.type == "AGENT_STRATEGY" ? (
                                    <div className="open_selecte_action_cont fade-in" key={openAction.id}>
                                        <div className="open_selecte_action_cont_header">
                                            <p className="open_selecte_action_cont_header_title fade-in">{openAction.target_url}</p>
                                            <p className="open_selecte_action_cont_header_type fade-in">{openAction.type}</p>
                                        </div>
                                        <div className="open_selecte_action_cont_body">
                                            <p className="open_selecte_action_cont_body_title fade-in">{openAction.title}</p>
                                            <p className="open_selecte_action_cont_body_summary fade-in">{openAction.summary}</p>

                                            <div className="open_selecte_action_cont_body_analysis">
                                                <p className="open_selecte_action_cont_body_analysis_title fade-in">{t.geo.analysis}</p>
                                                <p className="open_selecte_action_cont_body_analysis_cont fade-in">{openAction.current_page_analysis}</p>
                                            </div>

                                            <div className="open_selecte_action_cont_body_analysis">
                                                <p className="open_selecte_action_cont_body_analysis_title fade-in">
                                                    {t.geo.applied_strategy}
                                                </p>

                                                <div className="open_selecte_action_cont_body_analysis_cont fade-in">
                                                    {Object.entries(openAction.applied_strategy || {})
                                                        .filter(([key, value]) => {
                                                            if (value == null || value === "") return false;
                                                            if (Array.isArray(value) && value.length === 0) return false;
                                                            if (
                                                                typeof value === "object" &&
                                                                !Array.isArray(value) &&
                                                                Object.keys(value).length === 0
                                                            ) return false;

                                                            return true;
                                                        })
                                                        .map(([key, value]) => (
                                                            <p key={key}>
                                                                <strong>{t.geo[key]}:</strong>{" "}
                                                                {Array.isArray(value)
                                                                    ? value.join(", ")
                                                                    : typeof value === "object"
                                                                        ? JSON.stringify(value)
                                                                        : String(value)}
                                                            </p>
                                                        ))}
                                                </div>
                                            </div>

                                            <div className="open_selecte_action_cont_body_analysis">
                                                <p className="open_selecte_action_cont_body_analysis_title fade-in">
                                                    {t.geo.potential_outcome}
                                                </p>

                                                <div className="open_selecte_action_cont_body_analysis_cont fade-in">
                                                    {Object.entries(openAction.potential_outcome || {})
                                                        .filter(([key, value]) => {
                                                            if (value == null || value === "") return false;
                                                            if (Array.isArray(value) && value.length === 0) return false;
                                                            if (
                                                                typeof value === "object" &&
                                                                !Array.isArray(value) &&
                                                                Object.keys(value).length === 0
                                                            ) return false;

                                                            return true;
                                                        })
                                                        .map(([key, value]) => (
                                                            <p key={key}>
                                                                <strong>{t.geo[key]}:</strong>{" "}
                                                                {Array.isArray(value)
                                                                    ? value
                                                                        .map((item) =>
                                                                            ["high", "medium", "low"].includes(
                                                                                String(item).toLowerCase()
                                                                            )
                                                                                ? t.geo[String(item).toLowerCase()]
                                                                                : String(item)
                                                                        )
                                                                        .join(", ")
                                                                    : ["high", "medium", "low"].includes(
                                                                        String(value).toLowerCase()
                                                                    )
                                                                        ? t.geo[String(value).toLowerCase()]
                                                                        : typeof value === "object"
                                                                            ? JSON.stringify(value)
                                                                            : String(value)}
                                                            </p>
                                                        ))}
                                                </div>
                                            </div>

                                            <div className="open_selecte_action_cont_body_analysis">
                                                <p className="open_selecte_action_cont_body_analysis_title fade-in">
                                                    {t.geo.optimizations}
                                                </p>

                                                <div className="open_selecte_action_cont_body_analysis_cont fade-in">
                                                    {openAction.optimizations?.map((optimization, index) => {
                                                        const entries = Object.entries(optimization).filter(([key, value]) => {
                                                            if (value == null || value === "") return false;
                                                            if (Array.isArray(value) && value.length === 0) return false;
                                                            if (
                                                                typeof value === "object" &&
                                                                !Array.isArray(value) &&
                                                                Object.keys(value).length === 0
                                                            ) return false;

                                                            return true;
                                                        });

                                                        return (
                                                            <div
                                                                key={optimization.id || index}
                                                                className="optimization_item fade-in"
                                                            >
                                                                {entries.map(([key, value]) => (
                                                                    <p key={key}>
                                                                        <span className="item_key">{t.geo[key] || key.replace(/_/g, " ")}:</span>{" "}
                                                                        {Array.isArray(value)
                                                                            ? value
                                                                                .map((item) =>
                                                                                    ["high", "medium", "low"].includes(
                                                                                        String(item).toLowerCase()
                                                                                    )
                                                                                        ? t.geo[String(item).toLowerCase()]
                                                                                        : String(item)
                                                                                )
                                                                                .join(", ")
                                                                            : ["high", "medium", "low"].includes(
                                                                                String(value).toLowerCase()
                                                                            )
                                                                                ? t.geo[String(value).toLowerCase()]
                                                                                : typeof value === "object"
                                                                                    ? JSON.stringify(value)
                                                                                    : String(value)}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            {/* {openAction.analyzed_past_strategies.length > 0 && (
                                                <div className="open_selecte_action_cont_body_analysis">
                                                    <p className="open_selecte_action_cont_body_analysis_title fade-in">{t.geo.analyzed_strategies}</p>
                                                    <p className="open_selecte_action_cont_body_analysis_cont fade-in">{JSON.stringify(openAction.analyzed_past_strategies)}</p>
                                                </div>
                                            )} */}
                                        </div>
                                        <div className="open_selecte_action_cont_footer">
                                            <p className="open_selecte_action_cont_footer_cont">{openAction.code_description}</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="open_selecte_action_cont fade-in" key={openAction.id}>
                                        <div className="open_selecte_action_cont_header">
                                            <p className="open_selecte_action_cont_header_title fade-in">{t.geo.sim_monitoring_title}</p>
                                            <p className="open_selecte_action_cont_header_type fade-in">{openAction.type}</p>
                                        </div>
                                        <div className="open_selecte_action_cont_body">
                                            <p className="open_selecte_action_cont_body_title fade-in">{t.geo.monitoring_title} - {FormatDateTime(openAction.created_at)}</p>
                                            <p className="open_selecte_action_cont_body_summary fade-in">{t.geo.monitoring_summary}</p>
                                        </div>
                                    </div>
                                )
                            )
                        ) : (
                            <div className="no_action_selected_cont fade-in">
                                <div className="no_action_selected_cont_inner">
                                    <p className="no_action_selected_cont_title fade-in">{t.geo.select_action_title}</p>
                                    <p className="no_action_selected_cont_desc fade-in">{t.geo.select_action_desc}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}

export default GeoActionsMain